import { pagesService } from '@/api'

const initialState = () => ({
  id: null,
  pathname: null,
  created_at: null,
  updated_at: null
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async findOrCreate({ commit }) {
      const page = await pagesService.find({
        query: {
          title: document.title,
          href: window.location.href
        }
      })
      commit('assign', page)
      commit(
        'dots/active/page/assign',
        {
          page_id: page.id,
          url: window.location.href,
          title: document.title
        },
        { root: true }
      )

      return page
    }
  },
  mutations: {
    assign(state, { id, pathname, created_at, updated_at }) {
      state.id = id
      state.pathname = pathname
      state.created_at = created_at
      state.updated_at = updated_at
    }
  }
}
